const install = Vue => {
  // 千分位
  Vue.prototype.$format = num => {
    if (num == null || num == undefined) return 0
    var reg = /\d{1,3}(?=(\d{3})+$)/g
    return (num + '').replace(reg, '$&,')
  }
  // yyyy-mm
  Vue.prototype.$nowDate = () => {
    var now = new Date()
    var month = now.getMonth() + 1
    month = month > 9 ? month : '0' + month
    let monTime = now.getFullYear() + '-' + month
    return monTime
  }
  // 表格高度
  Vue.prototype.tableHeight = window.innerHeight - 300
}

export default install
